/**
 * 需求来源：docs/合作页、CJ Entity、Ads开户落地页3个/AI提示词.md（第2次提交 任务2）
 *   —— /partnership/home 按 partnership_home.html 完全重做 + 接入 i18next。
 * 注意事项：
 *  1. 4 大 section：Hero / Partner Directory(接口数据 + 前端筛选/搜索/排序/分页) / Brand Assets / CTA。
 *  2. cards / categories 来自接口（fetch.js 预取，随首屏 state 下发），失败兜底空数组；接口数据保持原值不翻译。
 *  3. 不引 Header/Footer（Layout 自动注入）；withSSR 包装导出，Comp.fetch = fetchData。
 *  4. 删改：仅保留 Partner category 筛选；卡片去 featured/tags/market，Visit partner 占整行；
 *     移除 Your target markets / Supported language 两个筛选模块。
 *  5. 静态文案统一走 getConstants(fullName)（i18next），render 期调用以便客户端拾取目标语言。
 */
import React from 'react';
import withSSR from '../../../hoc/withSSR';
import fetchData from './fetch';
import HeroSection from './HeroSection';
import PartnerDirectory from './PartnerDirectory';
import BrandAssets from './BrandAssets';
import PartnerCta from './PartnerCta';
import { getConstants } from './constants';
import './index.less';

/**
 * 合作页主根组件
 * @param {Object} props - withSSR 注入，props.pageData 为 fetch.js 返回数据
 */
function PartnershipHome(props) {
  const pageData = props.pageData || {};
  const cards = pageData.cards || [];
  const categories = pageData.categories || [];
  const fullName = pageData.fullName || 'CJdropshipping';
  const siteName = pageData.siteName || 'CJ';
  const C = getConstants(fullName, siteName);

  return (
    <div className="cj-partnership-page" data-gtag-module="partnership">
      <HeroSection t={C.HERO} />
      <PartnerDirectory cards={cards} categories={categories} t={C.DIRECTORY} />
      <BrandAssets t={C.BRAND} />
      <PartnerCta t={C.CTA} />
    </div>
  );
}

PartnershipHome.fetch = fetchData;

export default withSSR(PartnershipHome);
